module.exports = ".fline {\n    fill: none;\n    stroke: #0f0f0f;\n    stroke-width: 2;\n}\n\n.chosen-line {\n    stroke: #EF5656;\n    stroke-dasharray: 2,2;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/plots/compare-graph/compare-graph.component.css
// module id = ./src/app/projects/project/plots/compare-graph/compare-graph.component.css
// module chunks = main